import { defineStore } from 'pinia'
import type { VueKeycloakInstance } from '@dsb-norge/vue-keycloak-js'

interface AuthState {
  keycloak: VueKeycloakInstance | null
  lastReset: Date | null
  language: string
}

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => ({
    keycloak: null,
    lastReset: null,
    language: localStorage.getItem('language') || ''
  }),

  getters: {
    isAuthenticated: (state): boolean => {
      return state.keycloak?.authenticated ?? false
    },

    isLoggedIn: (state): boolean => {
      return state.keycloak?.authenticated ?? false
    },

    token: (state): string | undefined => {
      return state.keycloak?.token
    },

    tokenParsed: (state): any => {
      return state.keycloak?.tokenParsed
    },

    username: (state): string | undefined => {
      return state.keycloak?.tokenParsed?.preferred_username
    }
  },

  actions: {
    setKeycloak(keycloak: VueKeycloakInstance): void {
      this.keycloak = keycloak
    },

    setLastReset(date: Date): void {
      this.lastReset = date
    },

    setLanguage(lang: string) {
      this.language = lang
      localStorage.setItem('language', lang)
    },

    async login(): Promise<void> {
      if (this.keycloak?.login) {
        await this.keycloak.login()
      }
    },

    async logout(): Promise<void> {
      if (this.keycloak?.logoutFn) {
        await this.keycloak.logoutFn()
      }
    },

    async refreshToken(): Promise<boolean> {
      if (this.keycloak?.keycloak) {
        try {
          await this.keycloak.keycloak.updateToken(70)
          return true
        } catch (error) {
          console.error('Failed to refresh token:', error)
          return false
        }
      }
      return false
    }
  }
})
